module.exports = __webpack_public_path__ + "img/view.b3316e2b.svg";